(()=>{
  const d=document,w=window,root=d.documentElement,motionQuery=w.matchMedia('(prefers-reduced-motion: reduce)');
  root.classList.remove('no-js');
  if(motionQuery.matches)return;
  root.classList.add('motion-ready');
  const revealSelectors=['.section>.container','.product-card','.service','.trust-bar__item','.footer__grid>*','.footer__bottom','.collection-head>*','.collection-tools','.collection-empty>*','.page>*','.product-info>*','.cart-line','.newsletter>*','.editorial-band__copy>*','.editorial-card__content>*'];
  const reveal=[...new Set(revealSelectors.flatMap(s=>[...d.querySelectorAll(s)]))];
  reveal.forEach((el,i)=>{el.classList.add('motion-reveal');el.style.setProperty('--motion-delay',`${Math.min(i%6,5)*55}ms`)});
  const media=[...d.querySelectorAll('.editorial-card,.editorial-band__media,.product-card__media,.product-gallery>*')];
  media.forEach((el,i)=>{el.classList.add('motion-image','motion-clip');el.style.setProperty('--motion-delay',`${Math.min(i%4,3)*65}ms`)});
  /* .reveal (hero/mens-film content) is a separate, hand-placed class from an earlier system; folded into this
     same observer in Gate 3 (was previously a second, duplicate IntersectionObserver in vanto.js). */
  const legacyReveal=[...d.querySelectorAll('.reveal')];
  const observed=[...new Set([...reveal,...media,...legacyReveal])];
  /* Release the will-change hint once its transition actually finishes, instead of leaving elements
     permanently promoted to their own compositor layer after the one-shot reveal is long done (Gate 3). */
  const releaseWillChange=el=>{
    const onEnd=e=>{if(e.target===el&&e.propertyName==='transform'){el.style.willChange='auto';el.removeEventListener('transitionend',onEnd)}};
    el.addEventListener('transitionend',onEnd);
  };
  const activate=target=>{
    target.classList.add(target.classList.contains('reveal')?'is-visible':'is-in-view');
    if(target.classList.contains('motion-image')){
      [target.querySelector('img'),target.querySelector('video')].filter(Boolean).forEach(releaseWillChange);
    }else{
      releaseWillChange(target);
    }
  };
  if('IntersectionObserver'in w){
    const io=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){activate(entry.target);io.unobserve(entry.target)}}),{threshold:.08,rootMargin:'0px 0px -5% 0px'});
    observed.forEach(el=>io.observe(el));
  }else{
    observed.forEach(activate);
  }
  if(!w.matchMedia('(min-width:750px)').matches)return;
  const parallax=[...d.querySelectorAll('.hero__media,.editorial-band__media')];
  let ticking=false;
  const updateParallax=()=>{
    const vh=w.innerHeight;
    parallax.forEach(el=>{
      const r=el.getBoundingClientRect();
      if(r.bottom>0&&r.top<vh){
        const progress=(r.top+r.height/2-vh/2)/vh;
        el.style.setProperty('--vanto-parallax-y',`${Math.max(-18,Math.min(18,progress*-18))}px`);
      }
    });
    ticking=false;
  };
  const onScroll=()=>{if(!ticking){w.requestAnimationFrame(updateParallax);ticking=true}};
  w.addEventListener('scroll',onScroll,{passive:true});
  updateParallax();
  /* If the user enables reduced-motion mid-session, stop the ongoing parallax scroll work immediately
     rather than relying solely on the CSS !important override to mask it (Gate 3). */
  motionQuery.addEventListener('change',e=>{if(e.matches){w.removeEventListener('scroll',onScroll)}});
})();
